import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    isSuccess: false
};
var updatePermissionStatusSlice = createSlice({
    name: "updatePermissionStatus",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
            state.isSuccess = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isSuccess: true,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true,
                isSuccess: false
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updatePermissionStatusSlice_actions = updatePermissionStatusSlice.actions;
export var fetchData = _updatePermissionStatusSlice_actions.fetchData, fetchDataSuccess = _updatePermissionStatusSlice_actions.fetchDataSuccess, fetchDataFailure = _updatePermissionStatusSlice_actions.fetchDataFailure, resetState = _updatePermissionStatusSlice_actions.resetState;
export default updatePermissionStatusSlice.reducer;
